export const REMOTE_FREQUENCY = {
    FULL_TIME: 'fullTime',
    REGULARLY: 'regularly',
    OCCASIONALY: 'occasionally',
    NEVER: 'never'
};
